export class SecretConstants {
    public static readonly AadUserAccessGroupId: string = "483bedb7-a263-4103-ad9d-4d2ffc0ba458";
}